
import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { Table } from "@common/src/utils/decorator";
import { emptyToLine, splitThousands } from "@common/src/utils/common";
import TableEnableFlag from "@/components/scope/table-enable-flag.vue";
import dayjs from "dayjs";
import t from "@common/src/i18n/t";
import { addCurrencySymbol } from "@common/src/utils/tools";
const warehouse = namespace("warehouse");
const partsCategory = namespace("parts-category");
const employee = namespace("employee");
@Component({
  components: { TableEnableFlag }
})
@Table("loadListData")
export default class PushMoneyGather extends Vue {
  @partsCategory.Action getCategoryList;
  @warehouse.Action getWarehouseList;
  @employee.Action getStaffCommissionSummaryPage;
  addCurrencySymbol = addCurrencySymbol;
  searchForm = {
    staffName: "",
    warehouseCode: "",
    partsCategoryCode: "",
    brandCode: "",
    startOutboundDate: "",
    orderCreateTimeStart: "",
    orderCreateTimeEnd: "",
    orderSettlementTimeStart: dayjs().format("YYYYMMDD"),
    orderSettlementTimeEnd: dayjs().format("YYYYMMDD")
  };
  splitThousands = splitThousands;
  emptyToLine = emptyToLine;
  dayjs = dayjs;
  partsList: any[] = [];
  get searchList() {
    return [
      {
        label: t("v210801.employee-name"),
        type: "input",
        value: "",
        prop: "staffName"
      },

      {
        label: t("v210831.document-creation-date"),
        type: "daterange",
        value: "",
        prop: "orderCreateTimeStart"
      },
      {
        label: t("v210831.document-settlement-date"),
        type: "daterange",
        defaultVlaue: [dayjs().format("YYYYMMDD"), dayjs().format("YYYYMMDD")],
        value: [dayjs().format("YYYYMMDD"), dayjs().format("YYYYMMDD")],
        prop: "orderSettlementTimeStart"
      }
    ];
  }
  categoryList: any[] = [];
  warehouseList: any = [];
  created() {
    this.init();
  }
  async init() {
    this.loadListData();
    this.getWarehouseList({
      pageNum: 1,
      pageSize: 100
    }).then(data => {
      this.warehouseList = this.$safeValue(data, "data.list", []).map(item => {
        item.label = item.warehouseName;
        item.value = item.warehouseCode;
        return item;
      });
    });
    const data = await this.getCategoryList();
    this.categoryList = this.addLeafFlag(this.$safeValue(data, "data", []));
  }
  params = {
    flag: true,
    name: "",
    TimeStart: "",
    TimeEnd: "",
    createStart: "",
    createEnd: ""
  };
  handleLinkPartsDetail(row) {
    this.params = {
      flag: true,
      name: row.staffName,
      TimeStart: this.searchForm.orderSettlementTimeStart,
      TimeEnd: this.searchForm.orderSettlementTimeEnd,
      createStart: this.searchForm.orderCreateTimeStart,
      createEnd: this.searchForm.orderCreateTimeEnd
    };
    localStorage.setItem("pushMoneyGather", JSON.stringify(this.params));
    console.log("[ params ]", this.params);
    let { href } = this.$router.resolve({
      name: "pushMoneyQuery"
    });
    window.open(href, "_blank");
  }
  inventoryQty: any = "";
  inventoryAmount: any = "";
  @Table.LoadDataMethod()
  loadListData() {
    return this.getStaffCommissionSummaryPage({
      orderItems: this.mix_sortParams,
      ...this.searchForm,
      pageNum: this.mix_pageNum,
      pageSize: this.mix_pageSize,
      staffName: this.searchForm.staffName
    }).then(data => {
      this.partsList = this.$safeValue(data, "data.list", []);
      this.inventoryQty = data.data.commissionSum;
      this.inventoryAmount = data.data.commissionTotal;
      return data;
    });
  }
  addLeafFlag(list) {
    const f = function (list) {
      list.forEach(item => {
        if (!item.children || item.children.length < 1) {
          delete item.children;
        } else {
          f(item.children);
        }
      });
    };
    f(list);
    return list;
  }
  handleSearch(data) {
    this.mix_pageNum = 1;
    data.forEach(item => {
      if (item.prop) {
        if (item.prop === "partsCategoryCode") {
          this.searchForm[item.prop] = item.value[item.value.length - 1] || "";
        } else if (item.prop === "orderCreateTimeStart") {
          this.searchForm["orderCreateTimeStart"] = item.value ? item.value[0] : "";
          this.searchForm["orderCreateTimeEnd"] = item.value ? item.value[1] : "";
        } else if (item.prop === "orderSettlementTimeStart") {
          this.searchForm["orderSettlementTimeStart"] = item.value ? item.value[0] : "";
          this.searchForm["orderSettlementTimeEnd"] = item.value ? item.value[1] : "";
        } else {
          this.searchForm[item.prop] = item.value;
        }
      }
    });
    this.loadListData();
  }
}
